import React from "react";

export const colors = {
  likely: [[[1, 1, 0], [0, 0, 255]], [[0,0,0], [240, 240, 240]], [[0, 0, 1], [255, 255, 0]]],
  impact: [[[0, 1, 1], [255, 0, 0]], [[0,0,0], [240, 240, 240]], [[1, 0, 1], [0, 255, 0]]]
}
export const toRGBA = (color, a) => `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${a})`;

export const getColorRGB = (name, i, range=9) => {
  const mid = Math.floor(range / 2);
  const colorSet = colors[name];
  if(i === mid && range % 2 === 1){
    return colorSet[1][1];
  }else if(i < mid){
    const mult = (i / mid) * 256;
    const c1 = colorSet[0][0].map((n,i) => n * mult);
    const c2 = colorSet[0][1].map((n,i) => n + c1[i]);
    return c2;
  }else if(i >= mid){
    const mult = ((mid - (i-mid + (range % 2 === 0 ? 1 : 0)))/mid) * 256;
    const c1 = colorSet[2][0].map((n,i) => n*mult);
    const c2 = colorSet[2][1].map((n,i) => n + c1[i]);
    return c2;
  }
};
export const getColor = (name, i, a) => toRGBA(getColorRGB(name, i), a);
export const gray = (val) => [val*255, val*255, val*255];
export const avgColors = (colorA, colorB) => colorA.map((c, i) => (c + colorB[i])/2);

export function formatDateTime(dateString){
  return (<div style={{width:'5.65em', whiteSpace:'nowrap', fontSize:'0.85em',}} >
    <div style={{display:'flex', gap:'0.25em'}}>
      <div style={{whiteSpace:'nowrap'}} >{dateString ? new Date(dateString).toLocaleDateString() : ''}</div>
      <div style={{
        whiteSpace:'nowrap',
      }} >{dateString ? new Date(dateString).toLocaleTimeString() : ''}</div>
    </div>
  </div>);
}


export const colorMid = 4;
export const colorCount = 9;
export const colorGridStyles = {
  likelyN0: { backgroundColor: getColor("likely", 0, 0.25), '&:hover':{ backgroundColor: getColor("likely", 0, 0.5625) } },
  likelyN1: { backgroundColor: getColor("likely", 1, 0.25), '&:hover':{ backgroundColor: getColor("likely", 1, 0.5625) } },
  likelyN2: { backgroundColor: getColor("likely", 2, 0.25), '&:hover':{ backgroundColor: getColor("likely", 2, 0.5625) } },
  likelyN3: { backgroundColor: getColor("likely", 3, 0.25), '&:hover':{ backgroundColor: getColor("likely", 3, 0.5625) } },
  likelyN4: { backgroundColor: getColor("likely", 4, 0.25), '&:hover':{ backgroundColor: getColor("likely", 4, 0.5625) } },
  likelyN5: { backgroundColor: getColor("likely", 5, 0.25), '&:hover':{ backgroundColor: getColor("likely", 5, 0.5625) } },
  likelyN6: { backgroundColor: getColor("likely", 6, 0.25), '&:hover':{ backgroundColor: getColor("likely", 6, 0.5625) } },
  likelyN7: { backgroundColor: getColor("likely", 7, 0.25), '&:hover':{ backgroundColor: getColor("likely", 7, 0.5625) } },
  likelyN8: { backgroundColor: getColor("likely", 8, 0.25), '&:hover':{ backgroundColor: getColor("likely", 8, 0.5625) } },

  impactN0: { backgroundColor: getColor("impact", 0, 0.25), '&:hover':{ backgroundColor: getColor("impact", 0, 0.5625) } },
  impactN1: { backgroundColor: getColor("impact", 1, 0.25), '&:hover':{ backgroundColor: getColor("impact", 1, 0.5625) } },
  impactN2: { backgroundColor: getColor("impact", 2, 0.25), '&:hover':{ backgroundColor: getColor("impact", 2, 0.5625) } },
  impactN3: { backgroundColor: getColor("impact", 3, 0.25), '&:hover':{ backgroundColor: getColor("impact", 3, 0.5625) } },
  impactN4: { backgroundColor: getColor("impact", 4, 0.25), '&:hover':{ backgroundColor: getColor("impact", 4, 0.5625) } },
  impactN5: { backgroundColor: getColor("impact", 5, 0.25), '&:hover':{ backgroundColor: getColor("impact", 5, 0.5625) } },
  impactN6: { backgroundColor: getColor("impact", 6, 0.25), '&:hover':{ backgroundColor: getColor("impact", 6, 0.5625) } },
  impactN7: { backgroundColor: getColor("impact", 7, 0.25), '&:hover':{ backgroundColor: getColor("impact", 7, 0.5625) } },
  impactN8: { backgroundColor: getColor("impact", 8, 0.25), '&:hover':{ backgroundColor: getColor("impact", 8, 0.5625) } },
}


export const colorGridNoHoverStyles = {
  likelyN0: { backgroundColor: getColor("likely", 0, 0.25) },
  likelyN1: { backgroundColor: getColor("likely", 1, 0.25) },
  likelyN2: { backgroundColor: getColor("likely", 2, 0.25) },
  likelyN3: { backgroundColor: getColor("likely", 3, 0.25) },
  likelyN4: { backgroundColor: getColor("likely", 4, 0.25) },
  likelyN5: { backgroundColor: getColor("likely", 5, 0.25) },
  likelyN6: { backgroundColor: getColor("likely", 6, 0.25) },
  likelyN7: { backgroundColor: getColor("likely", 7, 0.25) },
  likelyN8: { backgroundColor: getColor("likely", 8, 0.25) },

  impactN0: { backgroundColor: getColor("impact", 0, 0.25) },
  impactN1: { backgroundColor: getColor("impact", 1, 0.25) },
  impactN2: { backgroundColor: getColor("impact", 2, 0.25) },
  impactN3: { backgroundColor: getColor("impact", 3, 0.25) },
  impactN4: { backgroundColor: getColor("impact", 4, 0.25) },
  impactN5: { backgroundColor: getColor("impact", 5, 0.25) },
  impactN6: { backgroundColor: getColor("impact", 6, 0.25) },
  impactN7: { backgroundColor: getColor("impact", 7, 0.25) },
  impactN8: { backgroundColor: getColor("impact", 8, 0.25) },
}